export default __webpack_public_path__ + "static/our-background-hero-1ccb527c249ac03fb1aa5be88d883398.jpg";